import * as React from 'react';

import { Advantage } from './components/Advantage';
import { VideoPlayer } from '../video-player';

import * as styles from './styles.css';

export function OnlinePurchase() {
  return (
    <div className={styles['container']}>
      <Advantage
        index={1}
        title="Забронируйте квартиру"
        text={`10 дней цена на неё не изменится, и никто другой не сможет её купить.
          Это стоит 5 000 рублей, понадобится только паспорт.`}
      />
      <Advantage
        index={2}
        title="Вся сделка – онлайн. Только в ПИК"
        text={`Сделка без визита в офис — это удобно, быстро и безопасно.
          Каждый шаг сделки отражается в личном кабинете,
          а оплатить покупку можно в ипотеку или привычным онлайн-платежом с банковской карты.`}
      />
      <Advantage
        index={3}
        title="Оплата"
        text={`Оплатите 100% стоимости квартиры банковской картой или оформите
          ипотеку онлайн — на специальных условиях для клиентов ПИК.`}
      />
      <VideoPlayer videoURL="HKp8AkTBmd4" containerStyle={styles['video-container']} />
      <p className={styles['block']}>
        На pik.ru удобно выбирать и покупать. Составляйте список избранного, сравнивайте варианты по разным параметрам,
        знакомьтесь с планировками в онлайн шоу-руме, бронируйте квартиру или оформите всю сделку не выходя из дома — от
        начала и до конца.
      </p>
      <p className={styles['block']}>
        ПИК — первый и единственный девелопер в России, предлагающий такой уровень цифровизации.
      </p>
    </div>
  );
}
